import { FC } from 'react'
import { Trophy } from '~/modules/Trophies/Domain/Trophy'
import styles from './FeaturedTrophyCard.module.scss'
import { useTranslation } from 'next-i18next'
import { capitalize } from '~/modules/Shared/Domain/Helpers/String'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Link from 'next/link'

interface Props {
  trophy: Trophy
}

export const FeaturedTrophyCard: FC<Props> = ({ trophy }) => {
  const { t } = useTranslation('featured_trophy')
  let date = ''
  let media

  if (trophy.date) {
    date = capitalize(trophy.date.toLocaleString({ month: 'long' })) +
      ' ' + trophy.date.toLocaleString({ year: 'numeric' })
  }

  if (trophy.animationUrl) {
    media = (
      <video
        className={ styles.featuredTrophyCard__trophyMedia }
        poster={ trophy.rawImageUrl }
        loop={ true }
        autoPlay={ true }
        playsInline={ true }
        muted={ true }
      >
        <source
          src={ trophy.animationUrl }
          type={ trophy.getAnimationUrlVideoType() }
        />
      </video>
    )
  } else {
    media = (
      <img
        className={ styles.featuredTrophyCard__trophyMedia }
        src={ trophy.rawImageUrl }
        alt={ trophy.description }
      />
    )
  }

  return (
    <div className={ styles.featuredTrophyCard__container }>
      <Link
        href={ `/trophies/${trophy.id}` }
        className={ styles.featuredTrophyCard__link }
      >
        { t('show_info_button') }
      </Link>

      <div
        className={ styles.featuredTrophyCard__trophyImageWrapper }
        data-qa="media-container"
      >
        { media }
      </div>

      <h1 className={ styles.featuredTrophyCard__trophyTitle }>
        <FontAwesomeIcon
          icon={ faArrowUpRight }
          className={ styles.featuredTrophyCard__trophyTitleIcon }
        />

        { trophy.findAttribute('Full Name')?.value }

        <small className={ styles.featuredTrophyCard__trophySubtitle }>
          { trophy.findAttribute('Award Type')?.value }
          { trophy.findAttribute('Award Type') && date ? ' | ' : '' }
          { date }
        </small>
      </h1>

      <strong className={ styles.featuredTrophyCard__trophyCompetition }>
        { trophy.findAttribute('Competition')?.value }
      </strong>

      <div className={ styles.featuredTrophyCard__trophyDescription }>
        <small className={ styles.featuredTrophyCard__trophyDescriptionTitle }>
          { capitalize(t('description_label')) }
        </small>

        { trophy.description }
      </div>
    </div>
  )
}
